module.exports = __webpack_public_path__ + "img/verification_rejected.3af2bf7b.png";